import Http from '@/api/http.js'

export default {

  indexSegmentByBrand(brand_id, filter){
    return Http.get(`brands/${brand_id}/segments`, {
      params: {
        ...filter
      }
    });
  },
  indexSegment(filter){
    return Http.get(`segments`, {
      params: {
        ...filter
      }
    });
  },

  showSegment(id){
    return Http.get(`segments/${id}`);
  },

  createSegment(new_segment){
    const {name, code} = new_segment
    return Http.post(`segments`, {
      segment:{
        name, code
      }
    })
  },
  
  updateSegment(up_segment){
    const {id, name, code} = up_segment
    return Http.put(`segments/${id}`, {
      segment:{
        id,
        name, code,
      }
    })
  },
}